var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"label":_vm.label,"value":_vm.value,"items":_vm.available,"item-text":"name","return-object":"","hide-no-data":"","open-on-clear":"","clearable":""},on:{"input":_vm.update},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var attrs = ref.attrs;
var item = ref.item;
var index = ref.index;
var selected = ref.selected;
var disabled = ref.disabled;
var parent = ref.parent;
return [_c('v-chip',_vm._b({key:index,attrs:{"small":"","input-value":selected,"disabled":disabled}},'v-chip',attrs,false),[_c('v-icon',{attrs:{"size":_vm.size,"color":item.color}},[_vm._v(_vm._s(item.icon))]),_c('span',[_vm._v(" "+_vm._s(item.name))])],1)]}},{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-chip',[_c('v-icon',{attrs:{"size":_vm.size,"color":item.color}},[_vm._v(_vm._s(item.icon))]),_c('span',[_vm._v(" "+_vm._s(item.name))])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }